const base = '/settings';

export const settingsRoutes = {
  base,
  admins: `${base}/admins`,
  users: `${base}/users`,
  application: `${base}/application`,
  versions: `${base}/versions`,
} as const;
